import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import ListCoupon from './submodules/list';
import CreateBulkCoupons from './submodules/createBulk';
import ShowPartnerCoupons from './submodules/showBulk';
import EditBulkCoupon from './submodules/editBulk';
import CloneCoupon from './submodules/clone';
import CloneBulkCoupons from './submodules/cloneBulk';
import CouponConversions from './submodules/conversions';
import CreateCoupon from './submodules/create';
import EditCoupon from './submodules/edit';

const PartnerCouponsDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.partnerCoupon}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].getCoupons]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListCoupon}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.partnerCoupon}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].createCoupon]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/clone`}
				component={CloneCoupon}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.partnerCoupon}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].createCoupon]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateCoupon}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.partnerCoupon}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].getCoupons]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/payoutDetails`}
				component={CouponConversions}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.partnerCoupon}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].updateCoupon]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/edit`}
				component={EditCoupon}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.partnerCoupon}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].createPartnerCoupons]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/bulk/create`}
				component={CreateBulkCoupons}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.partnerCoupon}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].createPartnerCoupons]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/bulk/clone`}
				component={CloneBulkCoupons}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.partnerCoupon}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].getPartnerCoupons]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/bulk/show`}
				component={ShowPartnerCoupons}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.partnerCoupon}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.partnerCoupon].updatePartnerCoupons]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/bulk/edit`}
				component={EditBulkCoupon}
				exact
			/>

			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default PartnerCouponsDashboard;
